"use strict";

(function ($) {

    // Initialize Mono Dynamic Slick Sliders
    function initMonoSliders($context) {
        var $sliders = ($context || $(document)).find('.mono-slider-container');
        $sliders.each(function () {
            var $slider = $(this);
            if ($slider.hasClass('slick-initialized')) {
                return;
            }

            var customOptions = $slider.data('slick-options');
            if (typeof customOptions === 'string') {
                try {
                    customOptions = JSON.parse(customOptions);
                } catch (e) {
                    customOptions = {};
                }
            }

            var defaultOptions = {
                dots: true,
                arrows: true,
                infinite: true,
                speed: 600,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 5000,
                pauseOnHover: true,
                adaptiveHeight: false,
                prevArrow: '<button type="button" class="slick-prev mono-slick-arrow mono-slick-prev" aria-label="Previous"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>',
                nextArrow: '<button type="button" class="slick-next mono-slick-arrow mono-slick-next" aria-label="Next"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>'
            };

            var finalOptions = $.extend(true, {}, defaultOptions, customOptions || {});
            $slider.slick(finalOptions);
        });
    }

    $(document).ready(function () {
        initMonoSliders();

        // Main Hero Slider
        $('.hero-slider-home-v3').slick({
            dots: true,
            autoplay: false,
            speed: 600,
            prevArrow: $('.prev'),
            nextArrow: $('.next'),
            slidesToShow: 1,
            infinite: false,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        arrows: false
                    }
                }
            ]
        });

        // Review Slider
        $('.reviews-slider-home-v2').slick({
            dots: true,
            autoplay: true,
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            speed: 500,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        // Product Category Slider
        $('.product-category-slider').slick({
            autoplay: true,
            speed: 600,
            arrows: true,
            dots: false,
            slidesToShow: 6,
            infinite: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });

    $(window).on('load', function () {
        initMonoSliders();
    });

    // Support WordPress Gutenberg Block Editor preview updates
    if (typeof wp !== 'undefined' && wp.domReady) {
        wp.domReady(function () {
            initMonoSliders();
        });
    }

    // Observer for dynamic block renders in Block Editor / AJAX
    if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                    initMonoSliders($(mutation.target));
                }
            });
        });
        $(document).ready(function () {
            var editorEl = document.querySelector('.block-editor-writing-flow') || document.body;
            if (editorEl) {
                observer.observe(editorEl, { childList: true, subtree: true });
            }
        });
    }

})(jQuery);

